'use strict';

// Contact workspace — a person record with a primary Organization FK plus M:N ties to Organizations and Projects.
// Overview + two association tabs.
module.exports = {
	Identifier: 'ContactWorkspace', Ordinal: 255,
	Entity: { Name: 'Contact', IDField: 'IDContact', Collection: 'Contacts', GUIDField: 'GUIDContact' },
	Header: { Eyebrow: 'Contact', Title: (r) => r.NameFull || `${r.NameFirst || ''} ${r.NameLast || ''}`.trim() || `Contact ${r.IDContact}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Contact/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'organizations', Label: 'Organizations', Icon: 'fas fa-building', Content: { kind: 'assoc', ref: 'ContactOrganization' } },
		{ Key: 'projects', Label: 'Projects', Icon: 'fas fa-folder-open', Content: { kind: 'assoc', ref: 'ContactProject' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'NameFirst', Label: 'First Name' }, { Key: 'NameLast', Label: 'Last Name' }, { Key: 'Title', Label: 'Title' }, { Key: 'IDOrganization', Label: 'Organization', Card: 'Organization' } ] },
		{ Name: 'Contact', Fields: [ { Key: 'Email', Label: 'Email', Wide: true }, { Key: 'Phone', Label: 'Phone' } ] },
	],
};
